module.exports = __webpack_public_path__ + "img/Basic-Details.b1e00df8.jpg";